/**
 * Utilitaires de manipulation des string
 */
const StringUtils = {

	/** 
	 * Compare les string a et b sans tenir compte de la casse
	 * retourne 0 si égales
	 */
	compareIgnoreCase(a, b) {

		if (!a && !b) {
			return 0
		}

		if (a && !b) {
			return 1
		}

		if (!a && b) {
			return -1
		}

		return a.localeCompare(b, 'fr', { sensitivity: 'base' })
	},

	/** 
	 * Retourne true si tous les mots sont présents dans le texte donné
	 */
	matchAll(text, words) {

		if (!text || 0 === text.length || !words || 0 === words.length) {
			return true
		}

		const textLower = this.replaceDiacritics(text.toLowerCase())
		let result = true

		words.forEach(word => {
			result = result && textLower.includes(this.replaceDiacritics(word.toLowerCase()))
		});

		return result
	},

	/**
	 * Remplace les accents
	 */
	replaceDiacritics(text) {
		return text
			.replace(/[ÀÁÂÃÄÅÃ]/g,"A")
			.replace(/[àáâãäåã]/g,"a")

			.replace(/[ÈÉÊË]/g,"E")
			.replace(/[èéêë]/g,"e")

			.replace(/[ÌÍÎÏ]/g,"I")
			.replace(/[ÌÍÎÏ]/g,"i")

			.replace(/[ÒÓÔÖØÕ]/g,"O")
			.replace(/[òóôöøõ]/g,"o")

			.replace(/[ÙÚÛÜ]/g,"U")
			.replace(/[ùúûü]/g,"u")

			.replace(/[Ç]/g,"C")
			.replace(/[ç]/g,"c")

			.replace(/[Ñ]/g,"N")
			.replace(/[ñ]/g,"n")
	}

}

export default StringUtils